import React, { useEffect, useState, useRef } from "react";
import { ValidationMessage, hasRole } from "../../components/Utils";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Form from "react-bootstrap/Form";
import {
  USER_EDIT,
  USER_UPDATE,
  USER_ROLE_LIST_DROPDOWN,
  MEMBER_CROWN_LIST_DROPDOWN,
  COUNTRY_LIST_DROPDOWN,
  STATE_LIST_DROPDOWN,
  CHAPTER_LIST_DROPDOWN,
  REGION_LIST_DROPDOWN,
  BLOOD_GROUP_LIST_DROPDOWN,
  CATEGORY_LIST_DROPDOWN,
  USER_LIST_DROPDOWN,
  MEMBER_TYPE_LIST_DROPDOWN,
} from "../../routes/routes";
import { toast } from "react-toastify";
import { USER_UPDATED } from "../../constant/constant";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import "flatpickr/dist/themes/material_red.css";
import moment from "moment";
import { FullPageLoader } from "../../components/common/Loader"; // Import the loader component
import { Image } from "react-bootstrap";

const UserEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [filter, setFilter] = useState([]);
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState({});
  const [chapterOptions, setChapterOptions] = useState({});
  const [roleOptions, setRoleOptions] = useState({});
  const [memberTypeOptions, setMemberTypeOptions] = useState({});
  const [crownOptions, setCrownOptions] = useState({});
  const [bloodGroupOptions, setBloodGroupOptions] = useState({});
  const [categoryOptions, setCategoryOptions] = useState({});
  // const [isPANMandatory, setIsPANMandatory] = useState(true);
  // const [isGSTMandatory, setIsGSTMandatory] = useState(true);
  const [isPANMandatory, setIsPANMandatory] = useState(false);
  const [isGSTMandatory, setIsGSTMandatory] = useState(false);
  const [userOptions, setUserOptions] = useState({});
  const [showReferredByMember, setShowReferredByMember] = useState(false);
  const [showOthers, setShowOthers] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [type, setType] = useState("password");
  const [type1, setType1] = useState("password");

  const selectStateRef = useRef(null);
  const selectRegionRef = useRef(null);
  const selectChapterRef = useRef(null);

  const handleStateClear = () => {
    selectStateRef.current.clearValue();
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleRegionClear = () => {
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleChapterClear = () => {
    selectChapterRef.current.clearValue();
  };

  const referredByOptions = [
    { value: 1, label: "Direct" },
    { value: 2, label: "ZIFF Member" },
    { value: 3, label: "Others" },
  ];

  const auth_user = JSON.parse(localStorage.getItem("user"));

  /**   *
   * @param {*} input
   * @param {*} callback
   */

  const submit = async (e) => {
    setLoading(true);
    setBtnDisabled(true);
    let requestBody = { ...form };
    axios
      .put(USER_UPDATE + id, requestBody, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(USER_UPDATED);
          navigate("/users");
        }
      })
      .catch((err) => {
        if (err.response.status === 422) {
          const error = err.response.data.error;
          setErrors(error);
          toast.error(err.response.data.msg);
        }
      })
      .finally(() => {
        setLoading(false);
        setBtnDisabled(false);
      });
  };

  const checkPanGstMandatory = (categoryId) => {
    if (Number(categoryId) === 202) {
      setIsPANMandatory(false);
      setIsGSTMandatory(false);
    } else {
      setIsPANMandatory(true);
      setIsGSTMandatory(true);
    }
  };

  useEffect(() => {
    axios
      .get(USER_EDIT + id)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          let responseData = res.data.data;

          responseData?.referred_by === 2
            ? setShowReferredByMember(true)
            : setShowReferredByMember(false);
          responseData?.referred_by === 3
            ? setShowOthers(true)
            : setShowOthers(false);

          setForm({
            name: responseData?.name,
            member_id: responseData?.member_id,
            email: responseData?.email,
            mobile_number: responseData?.mobile_number,
            whatsapp_mobile_number: responseData?.whatsapp_mobile_number,
            gender: String(responseData?.gender || "").toLowerCase(),
            // username: responseData?.username,
            company_name: responseData?.company_name,
            address: responseData?.address,
            bio_description: responseData?.bio_description,
            our_products_and_services: responseData?.our_products_and_services,
            dob: responseData?.dob
              ? moment(responseData?.dob, "DD/MM/YYYY").format("YYYY-MM-DD")
              : "",
            chapter_id: responseData?.chapter_id,
            cardImage: responseData.profile_image,
            country_id: responseData?.country_id,
            country_id_selected: {
              value: Number(responseData?.country_id),
              label: responseData?.country_name,
            },
            state_id: responseData?.state_id,
            state_id_selected: {
              value: Number(responseData?.state_id),
              label: responseData?.state_name,
            },
            region_id: responseData?.region_id,
            region_id_selected: {
              value: Number(responseData?.region_id),
              label: responseData?.region_name,
            },
            chapter_id_selected: {
              value: Number(responseData?.chapter_id),
              label: responseData?.chapter_name,
            },
            member_type: responseData?.member_type,
            member_type_selected: {
              value: Number(responseData?.member_type),
              label: responseData?.member_type_name,
            },
            category_id: responseData?.category_id,
            category_id_selected: {
              value: Number(responseData?.category_id),
              label: responseData?.category_name,
            },
            user_role_id: responseData?.user_role_id,
            user_role_id_selected: {
              value: Number(responseData?.user_role_id),
              label: responseData?.user_role_name,
            },
            date_of_joining: moment(
              responseData?.date_of_joining,
              "DD/MM/YYYY",
            ).format("YYYY-MM-DD"),
            membership_due_date: moment(
              responseData?.membership_due_date,
              "DD/MM/YYYY HH:mm:ss",
            ).format("YYYY-MM-DD"),
            crowns: responseData?.crowns,
            crowns_selected: {
              value: Number(responseData?.crowns),
              label: responseData?.crowns_name,
            },
            blood_group_id: responseData?.blood_group_id,
            blood_group_selected: {
              value: Number(responseData?.blood_group_id),
              label: responseData?.blood_group_name,
            },
            gst: responseData?.gst,
            pan: responseData?.pan,
            website: responseData?.website,
            instagram_personal_profile_link:
              responseData?.instagram_personal_profile_link,
            instagram_business_profile_link:
              responseData?.instagram_business_profile_link,
            linkedin_url: responseData?.linkedin_url,
            twitter_url: responseData?.twitter_url,
            youtube_url: responseData?.youtube_url,
            // facebook_url: responseData?.facebook_url,
            membership_status: responseData?.membership_status,
            referred_by: responseData?.referred_by,
            referred_by_selected: {
              value: Number(responseData?.referred_by),
              label: responseData?.referred_by_text,
            },
            referrer_id:
              responseData?.referred_by === 2
                ? responseData?.referrer_id
                : null,
            referrer_id_selected: {
              value: Number(responseData?.referrer_id),
              label: `${responseData?.ref_member_name} - ${responseData?.ref_member_region}- ${responseData?.ref_member_chapter}`,
            },
            referrer_name:
              responseData?.referred_by === 3
                ? responseData?.referrer_name
                : null,
            referrer_mobile:
              responseData?.referred_by === 3
                ? responseData?.referrer_mobile
                : null,
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch country data
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        const fetchedCountryOptions = countryResponse.data.data;
        setCountryOptions(fetchedCountryOptions);

        // Fetch state data
        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedStateOptions = stateResponse.data.data;
        setStateOptions(fetchedStateOptions);

        // Fetch region data
        const regionResponse = await axios.get(REGION_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedRegionOptions = regionResponse.data.data;
        setRegionOptions(fetchedRegionOptions);

        // Fetch chapter data
        const chapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedChapterOptions = chapterResponse.data.data;
        setChapterOptions(fetchedChapterOptions);

        // Fetch category data
        const categoryResponse = await axios.get(CATEGORY_LIST_DROPDOWN);
        const fetchedCategoryOptions = categoryResponse.data.data;
        setCategoryOptions(fetchedCategoryOptions);

        // Fetch role data
        const roleResponse = await axios.get(USER_ROLE_LIST_DROPDOWN);
        const fetchedRoleOptions = roleResponse.data.data;
        setRoleOptions(fetchedRoleOptions);

        // Fetch member type data
        const memberTypeResponse = await axios.get(MEMBER_TYPE_LIST_DROPDOWN);
        const fetchedMemberTypeOptions = memberTypeResponse.data.data;
        setMemberTypeOptions(fetchedMemberTypeOptions);

        // Fetch user data
        const userResponse = await axios.get(USER_LIST_DROPDOWN, {
          params: {},
        });
        const fetchedUserOptions = userResponse.data.data;
        setUserOptions(fetchedUserOptions);

        // Fetch crown data
        const crownResponse = await axios.get(MEMBER_CROWN_LIST_DROPDOWN);
        const fetchedCrownOptions = crownResponse.data.data;
        setCrownOptions(fetchedCrownOptions);

        // Fetch blood group data
        const bloodGroupResponse = await axios.get(BLOOD_GROUP_LIST_DROPDOWN);
        const fetchedBloodGroupOptions = bloodGroupResponse.data.data;
        setBloodGroupOptions(fetchedBloodGroupOptions);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [filter]);

  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-6">
              <h5 className="page-title">Members</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <Link to={"/users"}>
                    <span>Members List</span>
                  </Link>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Edit User</span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/users"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center">
                {/* <h5 className="mb-0">Edit User</h5> */}
              </div>
              <div className="card-body">
                <form>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="member_id">
                          Member ID<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="member_id"
                          placeholder="Member ID"
                          readOnly={true}
                          onChange={(e) =>
                            setForm({ ...form, member_id: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, member_id: e.target.value })
                          }
                          defaultValue={form?.member_id}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="name">
                          Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Name"
                          onChange={(e) =>
                            setForm({ ...form, name: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, name: e.target.value })
                          }
                          defaultValue={form?.name}
                        />
                        <ValidationMessage error={errors} name="name" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="email">
                          Email<span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder="Email"
                          onChange={(e) =>
                            setForm({ ...form, email: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, email: e.target.value })
                          }
                          defaultValue={form?.email}
                        />
                        <ValidationMessage error={errors} name="email" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="mobile_number">
                          Mobile Number<span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control hide-arrow"
                          id="mobile_number"
                          placeholder="Mobile No"
                          onChange={(e) =>
                            setForm({ ...form, mobile_number: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, mobile_number: e.target.value })
                          }
                          onInput={(e) => {
                            e.target.value = e.target.value
                              .replace(/\D/g, "")
                              .slice(0, 10);
                            setForm({ ...form, mobile_number: e.target.value });
                          }}
                          defaultValue={form?.mobile_number}
                        />
                        <ValidationMessage
                          error={errors}
                          name="mobile_number"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="whatsapp_mobile_number"
                        >
                          Whatsapp Mobile Number
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control hide-arrow"
                          id="whatsapp_mobile_number"
                          placeholder="Whatsapp Mobile No"
                          onChange={(e) =>
                            setForm({
                              ...form,
                              whatsapp_mobile_number: e.target.value,
                            })
                          }
                          onBlur={(e) =>
                            setForm({
                              ...form,
                              whatsapp_mobile_number: e.target.value,
                            })
                          }
                          onInput={(e) => {
                            e.target.value = e.target.value
                              .replace(/\D/g, "")
                              .slice(0, 10);
                            setForm({
                              ...form,
                              whatsapp_mobile_number: e.target.value,
                            });
                          }}
                          defaultValue={form?.whatsapp_mobile_number}
                        />
                        <ValidationMessage
                          error={errors}
                          name="whatsapp_mobile_number"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label d-block">
                          Gender <span className="text-danger">*</span>
                        </label>
                        <div className="form-check form-check-inline mt-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="gender"
                            id="genderMale"
                            value="male"
                            onChange={(e) =>
                              setForm({ ...form, gender: e.target.value })
                            }
                            checked={form.gender === "male"}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="genderMale"
                          >
                            Male
                          </label>
                        </div>
                        <div className="form-check form-check-inline mt-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="gender"
                            id="genderFemale"
                            value="female"
                            onChange={(e) =>
                              setForm({ ...form, gender: e.target.value })
                            }
                            checked={form.gender === "female"}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="genderFemale"
                          >
                            Female
                          </label>
                        </div>
                        <ValidationMessage error={errors} name="gender" />
                      </div>
                    </div>

                    {/* <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="username"
                        >
                          Username<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control hide-arrow"
                          id="username"
                          placeholder="Username"
                          onChange={(e) =>
                            setForm({ ...form, username: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, username: e.target.value })
                          }
                          defaultValue={form?.username}
                        />
                        <ValidationMessage error={errors} name="username" />
                      </div>
                    </div> */}

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="password">
                          Password<span className="text-danger">*</span>
                        </label>
                        <div className="input-group input-group-merge">
                          <input
                            type={type}
                            className="form-control"
                            id="password"
                            placeholder="***********"
                            aria-describedby="basic-default-password"
                            onChange={(e) =>
                              setForm({ ...form, password: e.target.value })
                            }
                            onBlur={(e) =>
                              setForm({ ...form, password: e.target.value })
                            }
                          />
                          {type === "password" ? (
                            <span
                              className="input-group-text cursor-pointer"
                              id="basic-default-password"
                              onClick={() => setType("text")}
                            >
                              <i className="bx bx-hide"></i>
                            </span>
                          ) : (
                            <span
                              className="input-group-text cursor-pointer"
                              id="basic-default-password"
                              onClick={() => setType("password")}
                            >
                              <i className="bx bx-show"></i>
                            </span>
                          )}
                        </div>
                        <ValidationMessage error={errors} name="password" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="confirm_password"
                        >
                          Confirm Password<span className="text-danger">*</span>
                        </label>
                        <div className="input-group input-group-merge">
                          <input
                            type={type1}
                            className="form-control"
                            id="confirm_password"
                            placeholder="***********"
                            aria-describedby="basic-default-password"
                            onChange={(e) =>
                              setForm({
                                ...form,
                                confirm_password: e.target.value,
                              })
                            }
                            onBlur={(e) =>
                              setForm({
                                ...form,
                                confirm_password: e.target.value,
                              })
                            }
                          />
                          {type1 === "password" ? (
                            <span
                              className="input-group-text cursor-pointer"
                              id="basic-default-password"
                              onClick={() => setType1("text")}
                            >
                              <i className="bx bx-hide"></i>
                            </span>
                          ) : (
                            <span
                              className="input-group-text cursor-pointer"
                              id="basic-default-password"
                              onClick={() => setType1("password")}
                            >
                              <i className="bx bx-show"></i>
                            </span>
                          )}
                        </div>
                        <ValidationMessage
                          error={errors}
                          name="confirm_password"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="company_name">
                          Company name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control hide-arrow"
                          id="company_name"
                          placeholder="Company name"
                          onChange={(e) =>
                            setForm({ ...form, company_name: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, company_name: e.target.value })
                          }
                          defaultValue={form?.company_name}
                        />
                        <ValidationMessage error={errors} name="company_name" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="address">
                          Address<span className="text-danger">*</span>
                        </label>
                        <textarea
                          type="text"
                          className="form-control hide-arrow"
                          id="address"
                          placeholder="Address"
                          rows="6"
                          maxlength="500"
                          onChange={(e) =>
                            setForm({ ...form, address: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, address: e.target.value })
                          }
                          defaultValue={form?.address}
                        />
                        <ValidationMessage error={errors} name="address" />
                      </div>
                    </div>

                    <div className="col-6">
                      <div className="d-flex justify-content-between">
                        <label htmlFor="profile_image" className="form-label">
                          Profile Image (1:1)
                          <span className="text-danger">*</span> (ex. 256wx256h)
                        </label>
                        <div className="d-flex gap-3 image-info">
                          <div>
                            <label>Max :</label>
                            <span>2MB</span>
                          </div>
                          {/* <div>
                            <label htmlFor="pixel">Min height*width: </label>
                            <span>430px * 600px</span>
                          </div> */}
                        </div>
                      </div>
                      <input
                        type="file"
                        className="form-control"
                        accept="image/jpeg, image/png, image/jpg"
                        onChange={(e) =>
                          e.target.files.length > 0
                            ? setForm({
                                ...form,
                                profile_image: e.target.files[0],
                                cardImage: URL.createObjectURL(
                                  e.target.files[0],
                                ),
                              })
                            : ""
                        }
                      />

                      <div className="m-3">
                        <Image
                          width={80}
                          height={80}
                          src={form?.cardImage}
                          rounded
                        />
                      </div>
                      <ValidationMessage error={errors} name="profile_image" />
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="bio_description">
                          Bio Description
                        </label>
                        <textarea
                          type="text"
                          className="form-control hide-arrow"
                          id="bio_description"
                          placeholder="Bio description"
                          rows="6"
                          maxlength="250"
                          onChange={(e) =>
                            setForm({
                              ...form,
                              bio_description: e.target.value,
                            })
                          }
                          onBlur={(e) =>
                            setForm({
                              ...form,
                              bio_description: e.target.value,
                            })
                          }
                          defaultValue={form?.bio_description}
                        />
                        <ValidationMessage
                          error={errors}
                          name="bio_description"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="our_products_and_services"
                        >
                          Our Products and Services
                        </label>
                        <textarea
                          type="text"
                          className="form-control hide-arrow"
                          id="our_products_and_services"
                          placeholder="Our Products and Services"
                          rows="6"
                          maxlength="250"
                          onChange={(e) =>
                            setForm({
                              ...form,
                              our_products_and_services: e.target.value,
                            })
                          }
                          onBlur={(e) =>
                            setForm({
                              ...form,
                              our_products_and_services: e.target.value,
                            })
                          }
                          defaultValue={form?.our_products_and_services}
                        />
                        <ValidationMessage
                          error={errors}
                          name="our_products_and_services"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="dob">
                          Date of Birth
                        </label>
                        <Flatpickr
                          className="form-control"
                          options={{
                            dateFormat: "Y-m-d",
                            enableTime: false,
                            maxDate: moment()
                              .subtract(18, "years")
                              .format("YYYY-MM-DD"),
                            onClose: (selected, dateStr, instance) => {
                              if (!selected || selected.length === 0) {
                                setForm({
                                  ...form,
                                  dob: null,
                                });
                              }
                            },
                            onChange: (selected) =>
                              setForm({
                                ...form,
                                dob: moment(selected[0]).format("YYYY-MM-DD"),
                              }),
                          }}
                          value={form?.dob}
                          placeholder="Select Date of Birth"
                        />
                        <ValidationMessage error={errors} name="dob" />
                      </div>
                    </div>

                    {hasRole([1]) && (
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="country_id" className="form-label">
                            Country<span className="text-danger">*</span>
                          </label>
                          <Select
                            isClearable
                            isDisabled={true}
                            options={countryOptions}
                            onChange={(selected) => {
                              handleStateClear();
                              setForm({
                                ...form,
                                country_id: selected?.value,
                                state_id: null,
                                region_id: null,
                                chapter_id: null,
                                country_id_selected: selected,
                                state_id_selected: null,
                                region_id_selected: null,
                                chapter_id_selected: null,
                              });
                              setFilter({
                                ...filter,
                                country_id: selected?.value,
                                state_id: null,
                                region_id: null,
                                chapter_id: null,
                              });
                            }}
                            value={form?.country_id_selected}
                          />
                          <ValidationMessage error={errors} name="country_id" />
                        </div>
                      </div>
                    )}

                    {hasRole([1, 6]) && (
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="state_id" className="form-label">
                            State<span className="text-danger">*</span>
                          </label>
                          <Select
                            isClearable
                            isDisabled={true}
                            ref={selectStateRef}
                            options={stateOptions}
                            onChange={(selected) => {
                              handleRegionClear();
                              setForm({
                                ...form,
                                state_id: selected?.value,
                                region_id: null,
                                chapter_id: null,
                                state_id_selected: selected,
                                region_id_selected: null,
                                chapter_id_selected: null,
                              });
                              setFilter({
                                ...filter,
                                state_id: selected?.value,
                                region_id: null,
                                chapter_id: null,
                              });
                            }}
                            value={form?.state_id_selected}
                          />
                          <ValidationMessage error={errors} name="state_id" />
                        </div>
                      </div>
                    )}

                    {hasRole([1, 6, 7]) && (
                      <div className="col-6 mb-3">
                        <label htmlFor="region_id" className="form-label">
                          Region<span className="text-danger">*</span>
                        </label>
                        <Select
                          isClearable
                          isDisabled={true}
                          ref={selectRegionRef}
                          options={regionOptions}
                          onChange={(selected) => {
                            handleChapterClear();
                            setForm({
                              ...form,
                              region_id: selected?.value,
                              chapter_id: null,
                              region_id_selected: selected,
                              chapter_id_selected: null,
                            });
                            setFilter({
                              ...filter,
                              region_id: selected?.value,
                              chapter_id: null,
                            });
                          }}
                          value={form?.region_id_selected}
                        />
                        <ValidationMessage error={errors} name="region_id" />
                      </div>
                    )}

                    {hasRole([1, 6, 7, 2]) && (
                      <div className="col-6 mb-3">
                        <label htmlFor="chapter_id" className="form-label">
                          Chapter<span className="text-danger">*</span>
                        </label>
                        <Select
                          isClearable
                          isDisabled={true}
                          ref={selectChapterRef}
                          options={chapterOptions}
                          onChange={(selected) => {
                            setForm({
                              ...form,
                              chapter_id: selected?.value,
                              chapter_id_selected: selected,
                            });
                            setFilter({
                              ...filter,
                              chapter_id: selected?.value,
                            });
                          }}
                          value={form?.chapter_id_selected}
                        />
                        <ValidationMessage error={errors} name="chapter_id" />
                      </div>
                    )}

                    <div className="col-6 mb-3">
                      <label htmlFor="member_type" className="form-label">
                        Member Type<span className="text-danger">*</span>
                      </label>
                      <Select
                        isClearable
                        options={memberTypeOptions}
                        onChange={(selected) => {
                          setForm({
                            ...form,
                            member_type: selected?.value,
                            member_type_selected: selected,
                          });
                        }}
                        value={form?.member_type_selected}
                      />
                      <ValidationMessage error={errors} name="member_type" />
                    </div>

                    <div className="col-6 mb-3">
                      <label htmlFor="user_role_id" className="form-label">
                        User Role<span className="text-danger">*</span>
                      </label>
                      <Select
                        options={roleOptions}
                        value={form?.user_role_id_selected}
                        onChange={(selected) =>
                          setForm({
                            ...form,
                            user_role_id: selected.value,
                            user_role_id_selected: selected,
                          })
                        }
                      />
                      <ValidationMessage error={errors} name="user_role_id" />
                    </div>

                    <div className="col-6 mb-3">
                      <label htmlFor="category_id" className="form-label">
                        Category<span className="text-danger">*</span>
                      </label>
                      <Select
                        options={categoryOptions}
                        value={form?.category_id_selected}
                        onChange={(selected) => {
                          setForm({
                            ...form,
                            category_id: selected.value,
                            category_id_selected: selected,
                          });
                          // checkPanGstMandatory(selected.value);
                        }}
                      />
                      <ValidationMessage error={errors} name="category_id" />
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="date_of_joining">
                          Date of Joining<span className="text-danger">*</span>
                        </label>
                        <Flatpickr
                          className="form-control"
                          options={{
                            dateFormat: "Y-m-d",
                            enableTime: false,
                            maxDate: "today",
                            onChange: (selected) =>
                              setForm({
                                ...form,
                                date_of_joining: moment(selected[0]).format(
                                  "YYYY-MM-DD",
                                ),
                              }),
                          }}
                          value={form?.date_of_joining}
                          placeholder="Select Date of Joining"
                        />
                        <ValidationMessage
                          error={errors}
                          name="date_of_joining"
                        />
                      </div>
                    </div>

                    <div className="col-6 mb-3">
                      <label htmlFor="crowns" className="form-label">
                        Member Crowns
                      </label>
                      <Select
                        isClearable
                        options={crownOptions}
                        value={form?.crowns ? form?.crowns_selected : ""}
                        onChange={(selected) =>
                          setForm({
                            ...form,
                            crowns: selected?.value,
                            crowns_selected: selected,
                          })
                        }
                      />
                      <ValidationMessage error={errors} name="crowns" />
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="membership_due_date"
                        >
                          Membership Due Date
                          <span className="text-danger">*</span>
                        </label>
                        <Flatpickr
                          className="form-control"
                          options={{
                            dateFormat: "Y-m-d",
                            enableTime: false,
                            onChange: (selected) =>
                              setForm({
                                ...form,
                                membership_due_date: moment(selected[0]).format(
                                  "YYYY-MM-DD",
                                ),
                              }),
                          }}
                          value={form?.membership_due_date}
                          placeholder="Select Date of Joining"
                        />
                        <ValidationMessage
                          error={errors}
                          name="membership_due_date"
                        />
                      </div>
                    </div>

                    <div className="col-6 mb-3">
                      <label htmlFor="blood_group_id" className="form-label">
                        Blood Group<span className="text-danger">*</span>
                      </label>
                      <Select
                        isClearable
                        options={bloodGroupOptions}
                        value={
                          form?.blood_group_id ? form?.blood_group_selected : ""
                        }
                        onChange={(selected) =>
                          setForm({
                            ...form,
                            blood_group_id: selected?.value,
                            blood_group_selected: selected,
                          })
                        }
                      />
                      <ValidationMessage error={errors} name="blood_group_id" />
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="gst">
                          GST Number
                          {isGSTMandatory && form?.category_id != 202 && (
                            <span className="text-danger">*</span>
                          )}
                        </label>
                        <input
                          type="text"
                          className="form-control hide-arrow"
                          id="gst"
                          placeholder="Gst"
                          onChange={(e) =>
                            setForm({
                              ...form,
                              gst: e.target.value.toUpperCase(),
                            })
                          }
                          onBlur={(e) =>
                            setForm({
                              ...form,
                              gst: e.target.value.toUpperCase(),
                            })
                          }
                          defaultValue={form?.gst?.toUpperCase()}
                        />
                        <ValidationMessage error={errors} name="gst" />
                      </div>
                    </div>

                    {/* <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="pan">
                          Pan Number
                          {isPANMandatory && form?.category_id != 202 && (
                            <span className="text-danger">*</span>
                          )}
                        </label>
                        <input
                          type="text"
                          className="form-control hide-arrow"
                          id="pan"
                          placeholder="Pan"
                          onChange={(e) =>
                            setForm({
                              ...form,
                              pan: e.target.value.toUpperCase(),
                            })
                          }
                          onBlur={(e) =>
                            setForm({
                              ...form,
                              pan: e.target.value.toUpperCase(),
                            })
                          }
                          defaultValue={form?.pan?.toUpperCase()}
                        />
                        <ValidationMessage error={errors} name="pan" />
                      </div>
                    </div> */}

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="website">
                          Website
                        </label>
                        <input
                          type="url"
                          className="form-control hide-arrow"
                          id="website"
                          placeholder="Website"
                          onChange={(e) =>
                            setForm({ ...form, website: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, website: e.target.value })
                          }
                          defaultValue={form?.website}
                        />
                        <ValidationMessage error={errors} name="website" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="instagram_personal_profile_link"
                        >
                          Instagram Personal Profile Link
                        </label>
                        <input
                          type="url"
                          className="form-control hide-arrow"
                          id="instagram_personal_profile_link"
                          placeholder="Instagram Personal Profile Link"
                          onChange={(e) =>
                            setForm({
                              ...form,
                              instagram_personal_profile_link: e.target.value,
                            })
                          }
                          onBlur={(e) =>
                            setForm({
                              ...form,
                              instagram_personal_profile_link: e.target.value,
                            })
                          }
                          defaultValue={form?.instagram_personal_profile_link}
                        />
                        <ValidationMessage
                          error={errors}
                          name="instagram_personal_profile_link"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="instagram_business_profile_link"
                        >
                          Instagram Business Profile Link
                        </label>
                        <input
                          type="url"
                          className="form-control hide-arrow"
                          id="instagram_business_profile_link"
                          placeholder="Instagram Business Profile Link"
                          onChange={(e) =>
                            setForm({
                              ...form,
                              instagram_business_profile_link: e.target.value,
                            })
                          }
                          onBlur={(e) =>
                            setForm({
                              ...form,
                              instagram_business_profile_link: e.target.value,
                            })
                          }
                          defaultValue={form?.instagram_business_profile_link}
                        />
                        <ValidationMessage
                          error={errors}
                          name="instagram_business_profile_link"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="linkedin_url">
                          Linkedin Url
                        </label>
                        <input
                          type="url"
                          className="form-control hide-arrow"
                          id="linkedin_url"
                          placeholder="Linkedin Url"
                          onChange={(e) =>
                            setForm({ ...form, linkedin_url: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, linkedin_url: e.target.value })
                          }
                          defaultValue={form?.linkedin_url}
                        />
                        <ValidationMessage error={errors} name="linkedin_url" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="twitter_url">
                          Twitter Url
                        </label>
                        <input
                          type="url"
                          className="form-control hide-arrow"
                          id="twitter_url"
                          placeholder="Twitter Url"
                          onChange={(e) =>
                            setForm({ ...form, twitter_url: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, twitter_url: e.target.value })
                          }
                          defaultValue={form?.twitter_url}
                        />
                        <ValidationMessage error={errors} name="twitter_url" />
                      </div>
                    </div>

                    {/* <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="facebook_url"
                        >
                          Facebook Url
                        </label>
                        <input
                          type="url"
                          className="form-control hide-arrow"
                          id="facebook_url"
                          placeholder="Facebook Url"
                          onChange={(e) =>
                            setForm({ ...form, facebook_url: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, facebook_url: e.target.value })
                          }
                          defaultValue={form?.facebook_url}
                        />
                        <ValidationMessage error={errors} name="facebook_url" />
                      </div>
                    </div> */}

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="youtube_url">
                          Youtube Url
                        </label>
                        <input
                          type="url"
                          className="form-control hide-arrow"
                          id="youtube_url"
                          placeholder="Youtube Url"
                          onChange={(e) =>
                            setForm({ ...form, youtube_url: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, youtube_url: e.target.value })
                          }
                          defaultValue={form?.youtube_url}
                        />
                        <ValidationMessage error={errors} name="youtube_url" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="referred_by">
                          Referred By<span className="text-danger">*</span>
                        </label>
                        <Select
                          name="referred_by"
                          options={referredByOptions}
                          onChange={(selected) => {
                            setForm({
                              ...form,
                              referred_by: selected.value,
                              referred_by_selected: selected,
                              referrer_id: null,
                              referrer_name: null,
                              referrer_mobile: null,
                            });
                            selected.value === 2
                              ? setShowReferredByMember(true)
                              : setShowReferredByMember(false);
                            selected.value === 3
                              ? setShowOthers(true)
                              : setShowOthers(false);
                          }}
                          value={form?.referred_by_selected}
                        />
                        <ValidationMessage error={errors} name="referred_by" />
                      </div>
                    </div>

                    {showReferredByMember && (
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label" htmlFor="referrer_id">
                            Referrer Members
                            <span className="text-danger">*</span>
                          </label>
                          <Select
                            name="referrer_id"
                            options={userOptions}
                            onChange={(selected) =>
                              setForm({
                                ...form,
                                referrer_id: selected.value,
                                referrer_id_selected: selected,
                                referrer_name: null,
                                referrer_mobile: null,
                              })
                            }
                            value={
                              form.referrer_id ? form.referrer_id_selected : ""
                            }
                          />
                          <ValidationMessage
                            error={errors}
                            name="referrer_id"
                          />
                        </div>
                      </div>
                    )}

                    {showOthers && (
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label" htmlFor="referrer_name">
                            Referrer Name<span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control hide-arrow"
                            id="referrer_name"
                            placeholder="Referrer name"
                            onChange={(e) =>
                              setForm({
                                ...form,
                                referrer_name: e.target.value,
                              })
                            }
                            onBlur={(e) =>
                              setForm({
                                ...form,
                                referrer_name: e.target.value,
                              })
                            }
                            defaultValue={form?.referrer_name}
                          />
                          <ValidationMessage
                            error={errors}
                            name="referrer_name"
                          />
                        </div>
                      </div>
                    )}

                    {showOthers && (
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label
                            className="form-label"
                            htmlFor="referrer_mobile"
                          >
                            Referrer Mobile Number
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            className="form-control hide-arrow"
                            id="referrer_mobile"
                            placeholder="Referrer Mobile Number"
                            onChange={(e) =>
                              setForm({
                                ...form,
                                referrer_mobile: e.target.value,
                              })
                            }
                            onBlur={(e) =>
                              setForm({
                                ...form,
                                referrer_mobile: e.target.value,
                              })
                            }
                            defaultValue={form?.referrer_mobile}
                          />
                          <ValidationMessage
                            error={errors}
                            name="referrer_mobile"
                          />
                        </div>
                      </div>
                    )}

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="membership_status"
                        >
                          Membership Status
                        </label>
                        <Form.Check
                          type="switch"
                          id="custom-switch"
                          value="1"
                          checked={form?.membership_status === 1}
                          label=""
                          onChange={(event) => {
                            const statusVal = event.target.checked ? 1 : 0;
                            setForm({
                              ...form,
                              membership_status: statusVal,
                            });
                          }}
                        />
                        <ValidationMessage
                          error={errors}
                          name="membership_status"
                        />
                      </div>
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/users"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="submit"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        &nbsp; Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserEdit;
